export default (function (_ref) {
  var service = _ref.service,
    request = _ref.request;
  return {
    // 列表
    getUserList: function getUserList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/user/get",
        method: "get",
        params: data
      });
    },
    // 列表
    getVipUserList: function getVipUserList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/user/getVipList",
        method: "get",
        params: data
      });
    },
    // 列表
    getRealNameUserList: function getRealNameUserList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/user_auth_info/get",
        method: "get",
        params: data
      });
    },
    // 列表
    getLogoutUserList: function getLogoutUserList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/user/getCancelUser",
        method: "get",
        params: data
      });
    },
    // 详情
    getUserInfo: function getUserInfo() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/user/getInfo",
        method: "get",
        params: data
      });
    },
    // 详情
    getUserBaseInfo: function getUserBaseInfo() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/user/getUserBaseInfo",
        method: "get",
        params: data
      });
    },
    // 新增
    addUser: function addUser() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/user/register",
        method: "post",
        data: data
      });
    },
    // 注册用户
    registerUser: function registerUser() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v1/admin/user/register",
        method: "post",
        data: data
      });
    },
    // 更新
    updateUser: function updateUser() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/user/updateUserInfo",
        method: "post",
        data: data
      });
    },
    // 注销
    logoutUser: function logoutUser() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/user/logout",
        method: "post",
        data: data
      });
    },
    // 设置 | 取消 待观察
    setUserObserved: function setUserObserved() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/user/setObserved",
        method: "post",
        data: data
      });
    },
    // 设置 | 取消 VIP
    setUserVip: function setUserVip() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/user/setVip",
        method: "post",
        data: data
      });
    },
    // 拉黑 | 恢复
    setUserDefriend: function setUserDefriend() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/user/opertionDefriend",
        method: "post",
        data: data
      });
    },
    // 设置用户备注
    setUserRemark: function setUserRemark() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/user/remark",
        method: "post",
        data: data
      });
    },
    // 设置用户品牌状态
    setUserBrand: function setUserBrand() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/user/setBrand",
        method: "post",
        data: data
      });
    },
    // 设置用户民宿状态
    setUserBnb: function setUserBnb() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/user/setBnb",
        method: "post",
        data: data
      });
    },
    // 切换用户类型
    setUserType: function setUserType() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v1/admin/user/set/user-type",
        method: "post",
        data: data
      });
    },
    // 审核用户
    setUserTypeStatus: function setUserTypeStatus() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v1/admin/user/set/user-type-status",
        method: "post",
        data: data
      });
    },
    // 禁言
    setUserDisableSendMsg: function setUserDisableSendMsg() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v1/admin/user/set/disable-send-msg",
        method: "post",
        data: data
      });
    },
    // 禁言
    setPassword: function setPassword() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/user/setPassword",
        method: "post",
        data: data
      });
    },
    // 换绑记录
    getPhoneUpdateRecord: function getPhoneUpdateRecord() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/user/getPhoneUpdateRecord",
        method: "get",
        params: data
      });
    },
    getUserListByPhone: function getUserListByPhone() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/user/getUserListByPhone",
        method: "post",
        data: data
      });
    },
    // 强制实名认证列表
    getForceAuthList: function getForceAuthList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v1/admin/user/auth",
        method: "get",
        params: data
      });
    },
    // 实名认证审核
    setForcAuthStatus: function setForcAuthStatus() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v1/admin/user/auth",
        method: "post",
        data: data
      });
    },
    // 设置强制实名认证
    setUserForcAuth: function setUserForcAuth() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v1/admin/user/auth/set",
        method: "post",
        data: data
      });
    },
    // 获取用户信息
    getUserInfoByPhone: function getUserInfoByPhone() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v1/admin/user/info",
        method: "get",
        params: data
      });
    },
    // 获取列表用户信息
    getUserListByIds: function getUserListByIds() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/user/getInfoByIds",
        method: "post",
        data: data
      });
    }
  };
});